import { BadgeCheck } from "lucide-react";
import VisitorCounter from "@/components/site/VisitorCounter";
import { HeroActions } from "@/components/site/HeroActions";

export default function Hero({ profile }) {
  if (!profile) return null;
  return (
    <header data-testid="site-hero" className="flex flex-col items-center text-center pt-5 pb-3 sb-fade-up">
      <div className="relative">
        <img
          data-testid="profile-avatar"
          src={profile.avatar_url}
          alt={profile.display_name}
          className="w-16 h-16 rounded-full object-cover"
          style={{ border: "2px solid var(--sb-border)", boxShadow: "0 0 24px rgba(0,230,118,0.15)" }}
        />
        <div
          className="absolute -bottom-0.5 -right-0.5 rounded-full p-[2px]"
          style={{ background: "var(--sb-bg)" }}
        >
          <div
            className="w-4 h-4 rounded-full flex items-center justify-center"
            style={{ background: "var(--sb-primary)" }}
          >
            <BadgeCheck size={10} color="#000" />
          </div>
        </div>
      </div>

      <h1 data-testid="profile-name" className="font-display text-xl md:text-2xl font-black mt-2 leading-tight">
        {profile.display_name}
      </h1>
      <div className="flex items-center gap-2 mt-1">
        <p data-testid="profile-handle" className="font-mono text-xs" style={{ color: "var(--sb-primary)" }}>
          {profile.handle}
        </p>
        <span style={{ color: "var(--sb-text-muted)" }} className="text-xs">·</span>
        <VisitorCounter />
      </div>
      <p
        data-testid="profile-bio"
        className="max-w-md mt-2 text-xs md:text-sm leading-snug px-4"
        style={{ color: "var(--sb-text-secondary)" }}
      >
        {profile.bio}
      </p>

      <HeroActions />
    </header>
  );
}
